<div class="layout-inner">
  <div class="content">
    <div class="image">
      <img src="assets/img/Ads_logo.svg" alt="{{'app.landing.transfer.alt-text' | translate}}">
    </div>
    <h3>{{'app.landing.transfer.title' | translate}}</h3>
  </div>
</div>
